import { z } from 'zod';
import { dateReelleSchema } from './comprehension.js';

// Les repas de la semaine (spec partage-cercles-et-repas, ecran Repas valide sur
// maquette le 2026-08-26). Partage API/application : meme regle, meme message.

// La date d'un repas est SAISIE : elle doit exister (audit du 2026-09-27). Le schema
// est celui de tout le projet, importe et non recopie.
const dateSchema = dateReelleSchema;

/** Deux creneaux par jour — a Dakar le dejeuner est le grand repas. */
export const creneauRepasSchema = z.enum(['DEJEUNER', 'DINER'], {
  message: 'Créneau invalide (DEJEUNER ou DINER)',
});

export const poserRepasSchema = z.object({
  date: dateSchema,
  creneau: creneauRepasSchema,
  titre: z.string().trim().min(1, 'Dis-moi quel plat').max(120, 'Le nom du plat est trop long'),
});

export const viderRepasSchema = z.object({
  date: dateSchema,
  creneau: creneauRepasSchema,
});

export const listeCoursesSemaineSchema = z.object({
  /** Le lundi de la semaine visee. */
  semaine: dateSchema,
});

export type CreneauRepas = z.infer<typeof creneauRepasSchema>;
export type PoserRepasInput = z.infer<typeof poserRepasSchema>;
